import { Space, Tooltip } from "antd"
import SectionIcon from "./SectionIcon"
import { ChecklistItemData, isItemChecked } from "./checklistModel"
import sectionsList from "./sectionsList"
import { green, orange } from "@ant-design/colors"

type Props = {
  steps?: ChecklistItemData[]
}


const ReportIcons = ({ steps }: Props) => {
  if (!steps) {
    return <></>
  }

  return <Space>
    {sectionsList.map(x => {
      const totalSteps = x.steps.length
      const completedSteps = x.steps.reduce((total, step) => total + (isItemChecked(steps, x.section, step.key) ? 1 : 0), 0)
      const style = completedSteps > 0
        ? { color: completedSteps === totalSteps ? green.primary : orange.primary }
        : undefined
      return <Tooltip key={x.section} title={x.title}>
        <span style={style}>
          <SectionIcon key={x.section} section={x.section} size="small" />
        </span>
      </Tooltip>
    }
    )}
  </Space>
}

export default ReportIcons
